import axios from 'axios';
import { getAPIHost, getExpressAPIHost } from '../../utils';
import Split from '../split';

const uploadImage = ({ base64 }) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const host = useExpress ? getExpressAPIHost() : getAPIHost();
        // Split-gate both host AND path: Express uses /s3/image-upload;
        // LoopBack uses the un-namespaced /image-upload.
        const path = useExpress ? '/s3/image-upload' : '/image-upload';
        const uploadRequest = axios.post(`${host}${path}`, { base64String: base64 });
        uploadRequest
            .then((uploadResponse) => {
                resolve({ imageInfo: uploadResponse.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error(errors.toString()));
            });
    });

export default uploadImage;
